import { createTheme } from "@mui/material";
import { themeInputs } from "./inputs";
import { themePalette } from "./colors";
import { themeTypography } from "./typography";
import { themeButtons } from "./buttons";

const theme = createTheme(themeTypography, themeButtons, themePalette, themeInputs);
export default theme;
